export function mapSkillLevelString(level) {
    switch (level) {
        case 'Beginner':
            return 1
        case 'Intermediate':
            return 2
        case 'Advanced':
            return 3
        default:
            return 1
    }
}
